import { render, staticRenderFns } from "./TheCode.vue?vue&type=template&id=2aebaddc"
import script from "./TheCode.vue?vue&type=script&lang=js"
export * from "./TheCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports